import {Injectable} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators} from '@angular/forms';
import {LorenEntityFormModel} from '../../../loren-entity-form-card/interfaces/loren-entity-form-model.interface.ts';
import {LorenFormField} from '../../../loren-entity-form-card/interfaces/loren-form-field.interface';
import {LorenFieldTypes} from '../../../loren-entity-form-card/enums/loren-field-types.enum';

@Injectable({
    providedIn: 'root'
})
export class LorenFormBuilderService {

    private static buildFieldValidators(field: LorenFormField): ValidatorFn[] {
        const validators: ValidatorFn[] = [];

        if (field.validator.required) {
            validators.push(Validators.required);
        }

        if (field.validator.maxLength) {
            validators.push(Validators.maxLength(field.validator.maxLength));
        }

        if (field.validator.minLength) {
            validators.push(Validators.minLength(field.validator.minLength));
        }

        if (field.validator.pattern) {
            validators.push(Validators.pattern(field.validator.pattern));
        }

        return validators;
    }

    public buildFormGroup(formModel: LorenEntityFormModel) {
        const form = new UntypedFormGroup({});
        formModel.formFields.forEach(field => {
            const formControl = new UntypedFormControl({
                value: !field.multiple ? field.value : field.values,
                disabled: field.disabled
            });

            if (field.validator) {
                formControl.setValidators(LorenFormBuilderService.buildFieldValidators(field));
            }

            if (field.formControlType === LorenFieldTypes.AUTOCOMPLETE) {
                field.filteredOptions = [];
                field.options.forEach(x => field.filteredOptions.push(Object.assign({}, x)));
            }

            form.addControl(field.name, formControl);
        });

        return form;
    }
}
